<div class="assets-container">
  <!-- Header Section -->
  <div class="assets-header">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-box"></i>
        <div class="header-text">
          <h1>Activos del Arrendamiento</h1>
          <p class="header-subtitle">Gestión y seguimiento de activos</p>
        </div>
      </div>
      <div class="header-right">
        <p-tag [value]="getTotalAssetsCount() + ' activo(s)'" severity="info" icon="pi pi-th-large"> </p-tag>
      </div>
    </div>
  </div>

  <!-- Plan v4.3 §7 · Tipo de activo que eligió el cliente: se compara con la categoría del activo que se asigna -->
  <div class="asset-type-row" *ngIf="quotationParameters">
    <app-asset-type-field
      [quotationParametersId]="quotationParameters._id"
      [assetType]="quotationParameters.assetType ?? null"
      (changed)="quotationParameters.assetType = $event"
    >
    </app-asset-type-field>
  </div>

  <!-- Assets List (Horizontal Cards) -->
  <div class="assets-list">
    <div class="asset-item" *ngFor="let asset of assets; let i = index" [attr.data-index]="i">
      <!-- Header Bar -->
      <div class="asset-header-bar">
        <div class="asset-header-left">
          <div class="asset-number-badge">
            <span>{{ i + 1 }}</span>
          </div>
          <div class="asset-title-info">
            <h2 class="asset-name">{{ asset.name }}</h2>
          </div>
        </div>
        <div class="asset-header-right">
          <p-tag [value]="asset.status" [severity]="getStatusSeverity(asset.status)" [icon]="getStatusIcon(asset.status)"> </p-tag>
        </div>
      </div>

      <!-- Content: 3 Column Layout - COMPACTO -->
      <div class="asset-content-grid">
        <!-- Column 1: Información General -->
        <div class="content-column">
          <div class="section-header">
            <i class="pi pi-info-circle"></i>
            <h3>Información General</h3>
          </div>

          <div class="compact-grid">
            <div class="compact-item" *ngIf="asset.brand">
              <span class="label">Marca</span>
              <span class="value">{{ asset.brand }}</span>
            </div>
            <div class="compact-item" *ngIf="asset.assetModel">
              <span class="label">Modelo</span>
              <span class="value">{{ asset.assetModel }}</span>
            </div>
            <div class="compact-item" *ngIf="asset.version && asset.version !== 'N/A'">
              <span class="label">Versión</span>
              <span class="value">{{ asset.version }}</span>
            </div>
            <div class="compact-item" *ngIf="asset.color">
              <span class="label">Color</span>
              <span class="value">{{ asset.color }}</span>
            </div>
            <div class="compact-item full-width" *ngIf="asset.serie">
              <span class="label">Número de Serie</span>
              <span class="value mono">{{ asset.serie }}</span>
            </div>
            <div class="compact-item full-width" *ngIf="asset.engineNumber && asset.engineNumber !== 'N/A'">
              <span class="label">Número de Motor</span>
              <span class="value mono">{{ asset.engineNumber }}</span>
            </div>
          </div>

          <!-- Descripción compacta -->
          <div class="description-compact" *ngIf="asset.description">
            <div class="section-header-mini">
              <i class="pi pi-align-left"></i>
              <span>Descripción</span>
            </div>
            <p>{{ asset.description }}</p>
          </div>
        </div>

        <!-- Column 2: Adquisición -->
        <div class="content-column">
          <div class="section-header">
            <i class="pi pi-shopping-cart"></i>
            <h3>Adquisición</h3>
          </div>

          <!-- Financial Summary Compacto -->
          <div class="financial-compact">
            <div class="financial-row">
              <span class="label">Subtotal</span>
              <span class="value">{{ asset.acquisition.amount | currency: 'MXN' : 'symbol' : '1.2-2' }}</span>
            </div>
            <div class="financial-row">
              <span class="label">IVA (16%)</span>
              <span class="value">{{ asset.acquisition.iva | currency: 'MXN' : 'symbol' : '1.2-2' }}</span>
            </div>
            <div class="financial-divider"></div>
            <div class="financial-row total">
              <span class="label">Total Factura</span>
              <span class="value">{{ asset.acquisition.total | currency: 'MXN' : 'symbol' : '1.2-2' }}</span>
            </div>
          </div>

          <div class="compact-item date-item" *ngIf="asset.acquisition.date">
            <i class="pi pi-calendar"></i>
            <div class="date-content">
              <span class="label">Fecha de Adquisición</span>
              <span class="value">{{ asset.acquisition.date | date: 'dd/MM/yyyy' }}</span>
            </div>
          </div>

          <!-- Entrega compacta -->
          <div class="delivery-compact" *ngIf="asset.delivery && asset.delivery.date">
            <div class="section-header-mini">
              <i class="pi pi-send"></i>
              <span>Entrega al Cliente</span>
            </div>
            <div class="compact-item date-item">
              <i class="pi pi-calendar"></i>
              <div class="date-content">
                <span class="label">Fecha</span>
                <span class="value">{{ asset.delivery.date | date: 'dd/MM/yyyy' }}</span>
              </div>
            </div>
            <div class="compact-item" *ngIf="asset.delivery.proof">
              <i class="pi pi-check-square"></i>
              <div class="date-content">
                <span class="label">Comprobante</span>
                <span class="value success">Disponible</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Column 3: Documentos -->
        <div class="content-column">
          <div class="section-header">
            <i class="pi pi-file"></i>
            <h3>Documentos</h3>
          </div>

          <div class="documents-compact" *ngIf="hasDocuments(asset); else noDocuments">
            <div class="doc-item" *ngIf="asset.acquisition.invoicePdf">
              <i class="pi pi-file-pdf"></i>
              <span>Factura PDF</span>
              <i class="pi pi-check-circle"></i>
            </div>
            <div class="doc-item" *ngIf="asset.acquisition.invoiceXml">
              <i class="pi pi-file-excel"></i>
              <span>Factura XML</span>
              <i class="pi pi-check-circle"></i>
            </div>
            <div class="doc-item" *ngIf="asset.acquisition.paymentProof">
              <i class="pi pi-wallet"></i>
              <span>Comp. Pago</span>
              <i class="pi pi-check-circle"></i>
            </div>
            <div class="doc-item" *ngIf="asset.acquisition.circulationCard">
              <i class="pi pi-id-card"></i>
              <span>T. Circulación</span>
              <i class="pi pi-check-circle"></i>
            </div>
            <div class="doc-item" *ngIf="asset.acquisition.vrn">
              <i class="pi pi-tag"></i>
              <span>Placas</span>
              <i class="pi pi-check-circle"></i>
            </div>
            <div class="doc-item" *ngIf="asset.acquisition.permisson">
              <i class="pi pi-verified"></i>
              <span>Permiso</span>
              <i class="pi pi-check-circle"></i>
            </div>
            <div class="doc-item" *ngIf="asset.acquisition.inssurancePolice">
              <i class="pi pi-shield"></i>
              <span>Seguro</span>
              <i class="pi pi-check-circle"></i>
            </div>
            <div class="doc-item" *ngIf="asset.acquisition.gps">
              <i class="pi pi-map-marker"></i>
              <span>GPS</span>
              <i class="pi pi-check-circle"></i>
            </div>
          </div>

          <ng-template #noDocuments>
            <div class="no-documents">
              <i class="pi pi-inbox"></i>
              <span>Sin documentos</span>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <!-- Activo provisional: lease originado sin activo real registrado -->
  <div class="provisional-card" *ngIf="isProvisionalAsset">
    <div class="provisional-banner">
      <i class="pi pi-exclamation-triangle"></i>
      <span>Este arrendamiento se originó con un activo provisional. Asigna el activo real cuando esté registrado.</span>
    </div>
    <div class="provisional-body">
      <div class="provisional-info">
        <div class="provisional-item">
          <span class="label">Activo provisional</span>
          <span class="value">{{ quotationParameters?.provitionalAsset || 'Activo por definir' }}</span>
        </div>
        <div class="provisional-item" *ngIf="quotationParameters?.provitionalValue">
          <span class="label">Valor estimado (con IVA)</span>
          <span class="value provisional-value">{{ quotationParameters?.provitionalValue | currency: 'MXN' : 'symbol' : '1.2-2' }}</span>
        </div>
        <p-tag value="Por definir" severity="warning" icon="pi pi-clock"></p-tag>
      </div>
      <button
        *appIfHasPermission="['leases', 'update']"
        pButton
        type="button"
        label="Asignar activo real"
        icon="fa-solid fa-link"
        class="p-button-success"
        (click)="assignAssetDialog.open()"
      ></button>
    </div>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="(!assets || assets.length === 0) && !isProvisionalAsset">
    <i class="pi pi-inbox"></i>
    <h3>No hay activos registrados</h3>
    <p>Este arrendamiento aún no tiene activos asociados</p>
  </div>
</div>

<!-- Asignación del activo real desde el tab Activos -->
<app-assign-asset-dialog
  #assignAssetDialog
  [leaseId]="leaseDetailService.data?._id"
  [provisionalValue]="quotationParameters?.provitionalValue"
  (assigned)="onAssetAssigned()"
></app-assign-asset-dialog>
